export const getPathToSports = (
  sportPath: string,
  cyberSportPath: string,
  sportId: number
) => (sportId === 85 ? cyberSportPath : sportPath);
